// extracted by mini-css-extract-plugin
module.exports = {"pillow":"paymentImage_pillow__kfAaM","highlighted":"paymentImage_highlighted__yEWNH"};